//lab-reconcillation
export const firstTableDayParam = "6";
export const defaultNumberValueForDropdown = 0;
export const SESSIONTIMEOUT = 90 * 60 * 1000;
export const search = [
  {
    value: 0,
    label: "DOS",
  },
  {
    value: 1,
    label: "Requistion Date",
  },
  {
    value: 2,
    label: "Recieved Date",
  },
];

export const formatDate = (date) => {
  if (!(date instanceof Date) || isNaN(date)) {
    throw new Error("The provided value is not a valid Date object.");
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(date.getDate()).padStart(2, "0");

  return `${month}/${day}/${year}`;
};

export const extractDate = (appointmentDate) => {
  const date = new Date(appointmentDate); // Create Date object from the string
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};

export const formatDateForInput = (date) => {
  if (!(date instanceof Date) || isNaN(date)) {
    throw new Error("The provided value is not a valid Date object.");
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const parseDateString = (dateString) => {
  if (!dateString) return null; // Handle empty string case
  const [year, month, day] = dateString.split("-").map(Number);
  if (isNaN(year) || isNaN(month) || isNaN(day)) return null; // Handle invalid date parts
  return new Date(year, month - 1, day); // Months are zero-based
};

export const formatDateForInput1 = (date) => {
  if (!(date instanceof Date) || isNaN(date)) {
    throw new Error("The provided value is not a valid Date object.");
  }

  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();
  return `${month}/${day}/${year}`; // MM/DD/YYYY format for UI display
};

export const parseDateString1 = (dateString) => {
  if (!dateString) return null; // Handle empty string case
  const [month, day, year] = dateString.split("/").map(Number);
  if (isNaN(month) || isNaN(day) || isNaN(year)) return null; // Handle invalid date parts
  return new Date(year, month - 1, day); // Months are zero-based in JavaScript
};

export function getCurrentTime(is24HourFormat = false) {
  // Get the current date and time
  const now = new Date();

  // Extract hours and minutes
  let hours = now.getHours();
  const minutes = now.getMinutes();

  if (is24HourFormat) {
    // Pad hours and minutes with leading zeros if needed
    hours = hours.toString().padStart(2, "0");
    const paddedMinutes = minutes.toString().padStart(2, "0");
    return `${hours}:${paddedMinutes}`;
  } else {
    // Determine AM or PM
    const period = hours >= 12 ? "PM" : "AM";

    // Convert hours from 24-hour to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    // Pad minutes with leading zeros if needed
    const paddedMinutes = minutes.toString().padStart(2, "0");

    // Format and return the time string
    return `${hours}:${paddedMinutes} ${period}`;
  }
}

export const getPreviousDate = (today) => {
  // const today = new Date();
  const prevDate = new Date(today);
  prevDate.setDate(today.getDate() - 1);
  return formattedDate(prevDate);
};

// Get Current Date in m-d-y format
export const getCurrentDate = (today) => {
  return formattedDate(today);
};

// Get Date Range for the Year
export const getDateRangeForYear = (today) => {
  const startOfYear = new Date(today.getFullYear(), 0, 1);
  const endOfYear = new Date(today.getFullYear(), 11, 31);

  const formattedStart = formattedDate(startOfYear) + "-";
  const formattedEnd = formattedDate(endOfYear);

  return [formattedStart, formattedEnd];
};

export const getDaysPassed = (today) => {
  const daysPassed = Math.abs(today.getDate() - 1);
  return `${daysPassed} day${daysPassed === 1 ? "" : "s"}`;
};

// Get Current Month Name
export const getCurrentMonthName = (today) => {
  const options = { month: "long" };
  return today.toLocaleDateString("en-US", options);
};

// Format Date in m-d-y
const formattedDate = (date) => {
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};

export const resultForRecoveryForm = [
  {
    value: "OK",
    label: "CONTROL OK",
  },
  {
    value: 'NOT DETECTED',
    label: "NOT DETECTED",
  },
  {
    value: 'DETECTED',
    label: "DETECTED",
  },
];

export const formatPhoneNumber = (value) => {
  if (!value) return "";

  const phoneNumber = value.replace(/\D/g, "").slice(0, 10);

  const areaCode = phoneNumber.slice(0, 3);
  const centralOfficeCode = phoneNumber.slice(3, 6);
  const lineNumber = phoneNumber.slice(6, 10);

  if (phoneNumber.length < 4) return `(${areaCode}`;
  if (phoneNumber.length < 7) return `(${areaCode}) ${centralOfficeCode}`;
  return `(${areaCode}) ${centralOfficeCode}-${lineNumber}`;
};